import React from 'react';
import { COLORS } from '../../styles/variables';

interface InfoIconProps {
  color?: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ color = COLORS.grey60 }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2056_10)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58334 14.1667V8.33335V14.1667ZM9.58334 6.66669V5.00002V6.66669ZM9.58334 18.75C14.6459 18.75 18.75 14.646 18.75 9.58335C18.75 4.52074 14.6459 0.416687 9.58334 0.416687C4.52073 0.416687 0.416672 4.52074 0.416672 9.58335C0.416672 14.646 4.52073 18.75 9.58334 18.75Z"
        stroke={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_2056_10">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default InfoIcon;
